import QueueItem from './queue-item'

export default class Queue {
  constructor() {
    this.items = [];
  }

  add({ args, func, item }) {
    this.items = this.items.filter(i => !i.done);
    const found = this.items.find(i => {
      return i.args.itemId === args.itemId
    });

    const id = this.items.indexOf(found);

    if(found === undefined) {
      this.items.push(new QueueItem({ args, func, item }));
    } else {
      if(args.hasOwnProperty('itemId')) {
        found.item = item;
        found.args = args;
        found.func = func;
      } 
      
      if(item === null) {
        found.args = args;
        found.item = item;
        found.func = func;
      }

      this.items[id] = found; 
    }
  }

  trigger() {
    return new Promise((resolve) => {
      if(this.items.length > 0) {
        this.items[0].trigger().then((result) => {
          this.items[0].done = true;
          this.items.splice(0, 1);
          this.items.length === 0 ? resolve(result) : this.trigger();        
        }).catch((err) => {
          console.error(err);
        });
      } else {
        resolve();
      }
    });
  }
}